import React from 'react'
import { Routes, Route } from 'react-router-dom';

import Login from '../../pages/login';
import NotFound from '../../components/NotFound';


function AuthRoute() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
}

export default AuthRoute